var exports = {
  "uW": "PlusAppearanceSettings.module__section___VVNnb3",
  "DD": "PlusAppearanceSettings.module__title___VVNnb3",
  "h_": "PlusAppearanceSettings.module__description___VVNnb3",
  "Os": "PlusAppearanceSettings.module__group___VVNnb3",
  "Pf": "PlusAppearanceSettings.module__label___VVNnb3",
  "qW": "PlusAppearanceSettings.module__fontGrid___VVNnb3",
  "A": "PlusAppearanceSettings.module__fontCard___VVNnb3",
  "s_": "PlusAppearanceSettings.module__fontSample___VVNnb3",
  "AG": "PlusAppearanceSettings.module__fontLabel___VVNnb3",
  "Gm": "PlusAppearanceSettings.module__fontCheck___VVNnb3",
  "_v": "PlusAppearanceSettings.module__fontSampleGradient___VVNnb3",
  "_r": "PlusAppearanceSettings.module__fontSampleDefaultOnLight___VVNnb3",
  "VH": "PlusAppearanceSettings.module__preview___VVNnb3",
  "B0": "PlusAppearanceSettings.module__previewCard___VVNnb3",
  "gz": "PlusAppearanceSettings.module__previewName___VVNnb3",
  "V": "PlusAppearanceSettings.module__modeGroup___VVNnb3",
  "KW": "PlusAppearanceSettings.module__colorRow___VVNnb3",
  "v2": "PlusAppearanceSettings.module__contrast___VVNnb3",
  "Vi": "PlusAppearanceSettings.module__contrastWarning___VVNnb3",
  "v4": "PlusAppearanceSettings.module__presets___VVNnb3",
  "IS": "PlusAppearanceSettings.module__preset___VVNnb3",
  "rM": "PlusAppearanceSettings.module__presetSelected___VVNnb3",
  "gJ": "PlusAppearanceSettings.module__errorMessage___VVNnb3",
};

module.exports = exports;
